document.addEventListener("click", async function(e) {

  if (e.target.id === "open-quote-modal") {
    document.getElementById("quote-modal").style.display = "block";
  }

  if (e.target.id === "quote-method") return;

  if (e.target.id === "send-quote") {

    const name = document.getElementById("quote-name").value;
    const company = document.getElementById("quote-company").value;
    //const method = document.getElementById("quote-method").value;
    const methodElement = document.querySelector('input[name="quote-method"]:checked');
    const method = methodElement ? methodElement.value : null;
    const email = document.getElementById("quote-email").value;
    const phone = document.getElementById("quote-phone").value;

    if (!name || !company || !method) {
      alert("Completa los campos requeridos.");
      return;
    }

    if (method === "email" && !email) {
      alert("Ingresa correo electrónico.");
      return;
    }

    if (method === "whatsapp" && !phone) {
      alert("Ingresa número WhatsApp.");
      return;
    }

    try {

      const cart = await fetch('/cart.js').then(r => r.json());

      await fetch("https://tuservidor.com/api/quote", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          customer: {
            name,
            company,
            method,
            email: method === "email" ? email : null,
            phone: method === "whatsapp" ? phone : null
          },
          cart
        })
      });

      alert("Cotización enviada correctamente.");
      document.getElementById("quote-modal").style.display = "none";

    } catch (error) {
      alert("Error enviando cotización.");
    }

  }

});

/*document.addEventListener("change", function(e) {

  if (e.target.id === "quote-method") {

    const value = e.target.value;

    document.getElementById("email-field").style.display =
      value === "email" ? "block" : "none";

    document.getElementById("phone-field").style.display =
      value === "whatsapp" ? "block" : "none";
  }

});*/

document.addEventListener("change", function(e) {

  if (e.target.name === "quote-method") {

    const value = e.target.value;

    document.getElementById("email-field").style.display =
      value === "email" ? "block" : "none";

    document.getElementById("phone-field").style.display =
      value === "whatsapp" ? "block" : "none";
  }

});
